import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'gatsby'

import { MEASUREMENTS } from '../../helpers/constants'

import { CategoryContext } from '../../context/CategoryContext'

export default function SubNavigation( props ) {

	const { clearCategory } = useContext( CategoryContext )
	const { navItem, toggleMenu, menuToggled, width } = props
	const [ active, setActive ] = useState( false )
	const [ firstClick, setFirstClick ] = useState( true )

	const isMobile = width < MEASUREMENTS.TABLET; // less than tablet

	useEffect(() => {
		setFirstClick( true )
		setActive( false )
	}, [ menuToggled ])

	const handleSubNavClick = ( e ) => {
		if ( !isMobile ) {
			return
		}

		if ( firstClick && isMobile ) {
			e.preventDefault()
			setFirstClick( false )
		} else {
			toggleMenu( false )
			setFirstClick( true )
		}
		setActive( !active )
	}

	return (
		<li className={`navigation__item navigation__item--has-dropdown ${active ? 'is-open': ''}`}>
			<div className="navigation__dropdown">
				<div className="navigation__link-container">
					<Link
						to={ navItem.url }
						className="navigation__link"
						activeClassName="active"
						onClick={ e => { clearCategory(); handleSubNavClick( e ); }}>
						{ navItem.label }
					</Link>
				</div>
				<ul className={`navigation__dropdown-options ${active ? 'is-open': ''}`}>
					{ navItem.subNavItems.map( subItem => (
						<li className="navigation__dropdown-option" key={ subItem.id }>
							<Link
								to={ subItem.url }
								className="navigation__link navigation__link--in-dropdown"
								activeClassName="active"
								onClick={() => { clearCategory(); toggleMenu( false ); }}>
								{ subItem.label }
							</Link>
						</li>
					) ) }
				</ul>
			</div>
		</li>
	)
}